import {
  enableProdMode,
  EnvironmentProviders,
  ErrorHandler,
  importProvidersFrom,
  Provider,
  provideZonelessChangeDetection,
} from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import {
  RouteReuseStrategy,
  provideRouter,
  withRouterConfig,
} from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { Drivers } from '@ionic/storage';
import { IonicStorageModule } from '@ionic/storage-angular';
import { SupabaseClient, createClient } from '@supabase/supabase-js';
import { Chart } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { Database } from 'supabase/types/supabase';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { environment } from './environments/environment';
import { BugSplatLogger, BugSplatLogLevel, BugSplatModule } from 'bugsplat-ng';
import {
  MyAngularErrorHandler,
  NullErrorHandler,
} from './app/common/error-handler/error-handler.service';

Chart.register(ChartDataLabels);

defineCustomElements(window);

if (environment.production) {
  enableProdMode();
}

const supabaseClient = createClient<Database>(
  environment.supabaseUrl,
  environment.supabaseKey,
);

let bugsplatProviders: (Provider | EnvironmentProviders)[] = [];

if (environment.production && environment.bugsplat) {
  bugsplatProviders = [
    importProvidersFrom(BugSplatModule.initializeApp(environment.bugsplat)),
    {
      provide: ErrorHandler,
      useClass: MyAngularErrorHandler,
    },
    {
      provide: BugSplatLogger,
      useValue: new BugSplatLogger(BugSplatLogLevel.log),
    },
  ];
} else {
  bugsplatProviders = [{ provide: ErrorHandler, useClass: NullErrorHandler }];
}

bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: SupabaseClient<Database>, useValue: supabaseClient },
    provideCharts(withDefaultRegisterables()),
    provideZonelessChangeDetection(),
    provideIonicAngular({
      mode: 'ios',
    }),
    importProvidersFrom(
      IonicStorageModule.forRoot({
        name: '__olympia_db',
        driverOrder: [Drivers.IndexedDB],
      }),
    ),
    provideRouter(
      routes,
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
    ),
    ...bugsplatProviders,
  ],
});
